import { Badge, DraftSVG, TimeSVG, CheckSVG } from "@newsela/angelou";

import {
  isFutureDateTime,
  monthDayYearFormat,
} from "@/assignments/utils/dateUtils";
import { Assignment } from "@/types/models/Assignment.interface";
import useAssignmentReducerContext from "@/view/utils/useAssignmentReducerContext";
import { badgeCss } from "./AssignmentStatusBadge.style";

export const AssignmentStatusBadge = () => {
  const { updatedAssignment } = useAssignmentReducerContext() as {
    updatedAssignment: Assignment;
  };

  if (!updatedAssignment?.content_id) return null;

  const {
    date_goes_live: dateGoesLive,
    date_modified: dateModified,
    is_draft: isDraft,
  } = updatedAssignment;

  const isScheduled = isFutureDateTime(dateGoesLive);

  const draftStatusProps = {
    color: Badge.color.black,
    statusText: "draft",
    SvgIcon: DraftSVG,
    text: `Draft saved ${monthDayYearFormat(dateModified) || ""}`,
  };

  const publishedStatusProps = {
    color: Badge.color.green,
    statusText: "published",
    SvgIcon: CheckSVG,
    text: `Assignment published ${monthDayYearFormat(dateGoesLive) || ""}`,
  };

  const scheduledStatusProps = {
    color: Badge.color.yellow,
    statusText: "scheduled",
    SvgIcon: TimeSVG,
    text: `Scheduled for ${monthDayYearFormat(dateGoesLive) || ""}`,
  };

  const determineStatus = () => {
    if (isDraft) return draftStatusProps;

    if (isScheduled) {
      return scheduledStatusProps;
    } else {
      return publishedStatusProps;
    }
  };

  const statusBadgeProps = determineStatus();

  if (statusBadgeProps.text.length === 0) return null;

  return (
    <Badge
      color={statusBadgeProps.color}
      dataProps={{
        "data-qa-selector": `assignment-status-badge-${statusBadgeProps.statusText}`,
        "data-testid": "assignment-status-badge",
      }}
      flavor={Badge.flavor.solid}
      size={Badge.size.lg}
      SvgIcon={statusBadgeProps.SvgIcon}
      text={statusBadgeProps.text}
      __cssFor={{
        root: badgeCss,
      }}
    />
  );
};

export default AssignmentStatusBadge;
